// extracted by mini-css-extract-plugin
module.exports = {"banner":"ImpersonationBanner_banner__1rlyq","exit":"ImpersonationBanner_exit__2GcFx"};